if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        $('.custom-complementary-products').removeClass('error');
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const selectedProductId = parseInt(
          document
            .querySelector("#product-picker-2")
            ?.getAttribute("data-product-id")
        );

        if($('.completary-products-checkbox').find('input[type="checkbox"]:checked').length > 0){
          if(isNaN(selectedProductId)){
            $('.custom-complementary-products').addClass('error');
            return;
          }
        }
        
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const formData = new FormData(this.form);

        // ✅ MAIN PRODUCT (Product 1)
        const mainVariantId = parseInt(
          document
            .querySelector("#product3-placeholder .selected-products-wrapper")
            ?.getAttribute("data-product-id")
        );
        const mainQuantity = parseInt(formData.get("quantity") || "1");

        // ✅ EXTRAS: Checkbox & Additional Products
        const checkbox = document.getElementById("selling_products");
        const includeExtras = checkbox?.checked;

        

        const freeProductId = parseInt(
          document
            .querySelector(".custom-free-products")
            ?.getAttribute("data-free-product")
        );

        const items = [
          {
            id: mainVariantId,
            quantity: mainQuantity,
          },
        ];

        if (includeExtras && !isNaN(selectedProductId)) {
          items.push({
            id: selectedProductId,
            quantity: 1,
          });

          if (!isNaN(freeProductId)) {
            items.push({
              id: freeProductId,
              quantity: 1,
            });
          }
        }

        if (!items || items.length === 0) {
          this.handleErrorMessage("Please select at least one product to add to cart.");
          this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.classList.remove("loading");
          this.querySelector(".loading__spinner").classList.add("hidden");
          return;
        }

        // ✅ DEBUG: Console Logs
        console.log("🟢 Main Variant ID:", mainVariantId);
        console.log("🟠 Product 2 Variant ID:", selectedProductId);
        console.log("🟣 Free Product Variant ID:", freeProductId);
        console.log("🛒 Final items to add:", items);

        // ✅ FETCH
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        config.headers["Accept"] = "application/json";
        delete config.headers["Content-Type"];

        const formPayload = new FormData();
        const uniqueId =
          "id-" +
          Date.now().toString(36) +
          "-" +
          Math.random().toString(36).substr(2, 9);
        formPayload.append("sections_url", window.location.pathname);

        
        items.forEach((item, index) => {
        formPayload.append("items[][id]", item.id);
        formPayload.append("items[][quantity]", item.quantity);
      
        const role =
          item.id === freeProductId
            ? "free"
            : item.id === mainVariantId
            ? "main"
            : item.id === selectedProductId
            ? "addon"
            : "other";
      
        formPayload.append("items[][properties][_bundleRole]", role);
        formPayload.append("items[][properties][_bundleId]", uniqueId);
        formPayload.append("items[][properties][_uniqueKey]", `${uniqueId}-${index}-${item.id}`);
      });


        
        formPayload.append(
          "sections",
          this.cart.getSectionsToRender().map((section) => section.id)
        );

        config.body = formPayload;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
             
              return;
            }else if (response.errors) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.errors,
              });
              this.handleErrorMessage(response.errors);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
             
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          console.log('jgsgh' + errorMessage)
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
